module.exports = __webpack_public_path__ + "img/wxQr.cdb261a8.jpg";